export const previewClass = {
  text: "preview-text-promo-th",
  horizontal: "preview-tile-promo-th",
  invisible: "preview-invisible-promo-th",
  scheduled_push: "preview-push-promo-th",
};
